import { createStore } from '@/utils/store';
import { useLocalObservable } from 'mobx-react-lite';
import { C_STORAGE } from './constant';
import { removeStorage, setStorage } from './utils/storage';
import { RouteObject } from 'react-router-dom';
import { isEmpty, isEqual } from 'lodash';
import AsideLayout from './layouts/AsideLayout';
import { ErrorComponent } from './components/ErrorBoundary';
import Login from './pages/Login';
import { businessRouteChildren } from './routes';

const defaultRoutes: RouteObject[] = [
  {
    path: '/',
    Component: AsideLayout,
    ErrorBoundary: ErrorComponent,
    children: businessRouteChildren,
  },
  {
    path: 'login',
    ErrorBoundary: ErrorComponent,
    Component: Login,
  },
];

interface IProvince {
  id: string;
  name: string;
  childNum: number;
  sortName: string;
  fetched?: boolean;
  children?: IProvince[];
}

export interface IStoreType {
  routes: RouteObject[];
  setRoutes: Function;
  auth: API.Auth.AuthInfo; // 当前账户
  setAuth: Function;
  role: API.System.Role[]; // 角色列表
  setRole: Function;
  menu: API.MenuItem[]; // 菜单列表
  setMenu: Function;
  tags: API.MenuItem[];
  setTags: Function;
  provinces: IProvince[];
  setProvinces: Function;
  countries: string[];
  setCountries: Function;
}
export function useModel() {
  const store = useLocalObservable<IStoreType>(
    (): IStoreType => ({
      routes: defaultRoutes,
      setRoutes(routes: RouteObject[]) {
        this.routes = routes;
      },
      auth: {} as API.Auth.AuthInfo,
      setAuth(auth: API.Auth.AuthInfo) {
        if (isEmpty(auth)) removeStorage(C_STORAGE.TOKEN);
        if (isEqual(this.auth, auth)) return;
        this.auth = auth;
        setStorage(C_STORAGE.AUTH, auth);
      },
      role: [],
      setRole(role: API.System.Role[]) {
        this.role = role;
      },
      menu: [],
      setMenu(menu: API.MenuItem[]) {
        this.menu = menu;
      },
      tags: [],
      setTags(tags: API.MenuItem[] = []) {
        this.tags = tags;
      },
      provinces: [],
      setProvinces(provinces: IStoreType['provinces']) {
        this.provinces = provinces;
      },
      countries: [],
      setCountries(countries: IStoreType['countries']) {
        this.countries = countries;
      },
    }),
  );
  return store;
}
const store = createStore(useModel);
export const Provider = store.Provider;
export const useStore = store.useStore;
